import React from 'react';
import PropTypes from 'prop-types';

import './FormFeedback.css';

export const FormFeedback = ({ validationMessages }) => {
  if (!validationMessages || validationMessages.length <= 0) return null;
  return (
    <div className='message-list'>
      <div>
        {validationMessages.map((message, idx) => (
          <li key={idx}>{message}</li>
        ))}
      </div>
    </div>
  );
};

FormFeedback.propTypes = {
  validationMessages: PropTypes.arrayOf(PropTypes.string)
};
